export const REDUCER_NAME = 'transfer-drive-files'




// WEBPACK FOOTER //
// ./src/modules/customer/state/transfer-drive-files/const.js